﻿import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { ConfigurationApi } from '../../../../../generated/internalApi/api/api';
import { SessionService } from '../session/shared/session/session-service/session.service';
import { ApiService } from '../api.service';
import { ConfigStateRequirementData, SystemString } from '@app/shared/models';

export { ConfigurationApi };

export enum ConfigKey {
  CoborrowerEnabled = <any> 'Coborrower_Enabled',
  CpUrl = <any> 'CPUrl',
  FinicityBankLinkingEnabled = <any> 'FinicityBankLinking_Enabled',
  FormFree_Enabled = <any> 'FormFree_Enabled',
  HomeImprovementEnabled = <any> 'HomeImprovementLoans_Enabled',
  HmdaEnabled = <any> 'HMDA_Enabled',
  MitekEnabled = <any> 'Mitek_Enabled',
  MixpanelToken = <any> 'MixpanelToken',
  PersonalLoansBeta_Enabled = <any> 'PersonalLoansBeta_Enabled',
  PersonalLoansDashboard_Enabled = <any> 'PersonalLoansDashboard_Enabled',
  PersonalLoans_Enabled = <any> 'PersonalLoans_Enabled',
  PricingEnabled = <any> 'Pricing_Enabled',
  StateLendingEnabled = <any> 'StateLending_Enabled',
  TWNEnabled = <any> 'TWN_Enabled',
  ULATest_UI_Route_Enabled = <any> 'ULATest_UI_Route_Enabled',
  UnifiedLoginEnabled = <any> 'UnifiedLogin_Enabled',
  UnityBase = <any> 'UNITYBASE'
}

interface ConfigResponseCache {
  legalCopy: { [key: string]: string };
}

@Injectable()
export class ConfigurationService extends ApiService {
  private cache: ConfigResponseCache = {
    legalCopy: {}
  };

  constructor(
    private configurationApi: ConfigurationApi,
    protected sessionService: SessionService) {

    super(sessionService);
  }

  public getConfigValueByKey(key: ConfigKey): Observable<string> {
    return this.configurationApi.configurationGetConfigValue(
      key ? key.toString() : '',
      this.authToken
    )
    .map(response => response.data)
    .catch(this.apiErrorHandler);
  }

  public getMaintenanceStatus(): Observable<boolean> {
    return this.configurationApi.configurationGetMaintenanceStatus(
      this.authToken
    )
    .map(response => response.data)
    .catch(this.apiErrorHandler);
  }

  public getPlLoanLegalCopy(): Observable<string> {
    let result: Observable<SystemString>;
    const cacheKey = this.plData.loanApplicationGuid || 'default';
    const cachedValue: string = this.cache.legalCopy[cacheKey];

    // Return the cached value if set.
    if (cachedValue) {
      return of(cachedValue);
    }

    // Or... Get fresh data...

    if (this.plData.loanApplicationGuid) {
      result = this.configurationApi.configurationGetPersonalLoanLegalCopy_1(
        this.plData.loanApplicationGuid,
        this.authToken
      );
    } else {
      result = this.configurationApi.configurationGetPersonalLoanLegalCopy(
        this.authToken
      );
    }

    return result.map(res => {

      // Cache the data here.
      this.cache.legalCopy[cacheKey] = res.data;
      return res.data;
    }).catch(this.apiErrorHandler);
  }

  public getPlStateRequirementList(): Observable<ConfigStateRequirementData[]> {
    return this.configurationApi.configurationGetPersonalLoanStateRequirementList(
      this.authToken
    )
    .map(res => res.data)
    .catch(this.apiErrorHandler);
  }
}
